<ng-template [ngIf]="!horizontal">
  <div class="header">
    <app-avatar class="card-img"
                [imageSrc]="record?.imageURL">
    </app-avatar>
  </div>
  <div class="card-content-vertical">
    <div class="card-row">
      <div class="card-name">
        {{ record?.title }}
      </div>
      <div class="card-details added-on">
        <span>{{ 'pages.customers.card.card-details.addedOn' | translate }}</span>
        <span> {{ record?.createdDate || 'N/A'}}</span>
      </div>
    </div>
    <div class="card-row">
      <div class="card-details bottom-left-details">
        <div>
          {{ 'pages.customers.card.card-details.totalCampaigns' | translate:{totalCampaigns: record?.totalCampaigns || 'N/A'} }}
        </div>
        {{ 'pages.customers.card.card-details.totalOperators' | translate:{totalOperators: record?.totalOperators || 'N/A'} }}
      </div>
      <div class="card-details bottom-right-details">
        <div>
          {{ 'pages.customers.card.card-details.totalCallTasks' | translate:{totalCallTasks: record?.totalCallTasks || 'N/A'} }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="record?.action"
       class="card-action-container">
    <app-button (clicked)="onClick($event)">{{ 'pages.campaigns.card.header.details' | translate }}</app-button>
  </div>
</ng-template>

<ng-template [ngIf]="horizontal">
  <app-avatar class="card-img"
              [imageSrc]="record?.imageURL">
  </app-avatar>
  <div class="card-content">
    <div class="card-details">
      <div class="title-container">
        <div class="card-title">{{record.title}}</div>
        <div class="card-subtitle">{{record.subtitle}}</div>
      </div>
      <div class="card-status"
           *ngIf="record.status">
        <span class="separator">-</span>
        <span class="text"
              [ngClass]="[record.status | lowercase]">{{record.status}}</span>
      </div>
    </div>
    <div class="card-action-container">
      <app-button *ngIf="record.action"
                  class="card-action"
                  [disabled]="isActionDisabled"
                  simple="true"
                  (clicked)="cardAction()">
        {{record.action | translate}}
      </app-button>
    </div>
  </div>
</ng-template>
